/**
 * 3D tilt for product cards (.card-3d): the card leans toward the pointer and a glare follows it.
 * Mouse/trackpad only; skipped entirely when the shopper prefers reduced motion.
 */
const canHover = window.matchMedia('(hover: hover) and (pointer: fine)');
const reduceMotion = window.matchMedia('(prefers-reduced-motion: reduce)');
const MAX_TILT = 10;
let activeCard = null;
let frame = 0;

function reset(card) {
  card.style.removeProperty('--tilt-x');
  card.style.removeProperty('--tilt-y');
  card.style.removeProperty('--glare-x');
  card.style.removeProperty('--glare-y');
  card.removeAttribute('data-tilting');
}

document.addEventListener('pointermove', (event) => {
  if (!canHover.matches || reduceMotion.matches || event.pointerType !== 'mouse') return;
  const card = event.target instanceof Element ? event.target.closest('.card-3d') : null;
  if (activeCard && activeCard !== card) reset(activeCard);
  activeCard = card;
  if (!card) return;
  cancelAnimationFrame(frame);
  frame = requestAnimationFrame(() => {
    const rect = card.getBoundingClientRect();
    const px = (event.clientX - rect.left) / rect.width;
    const py = (event.clientY - rect.top) / rect.height;
    card.style.setProperty('--tilt-x', `${((0.5 - py) * MAX_TILT * 2).toFixed(2)}deg`);
    card.style.setProperty('--tilt-y', `${((px - 0.5) * MAX_TILT * 2).toFixed(2)}deg`);
    card.style.setProperty('--glare-x', `${(px * 100).toFixed(1)}%`);
    card.style.setProperty('--glare-y', `${(py * 100).toFixed(1)}%`);
    card.setAttribute('data-tilting', '');
  });
}, { passive: true });

document.addEventListener('pointerleave', () => { if (activeCard) reset(activeCard); activeCard = null; }, true);
document.documentElement.addEventListener('mouseleave', () => { if (activeCard) reset(activeCard); activeCard = null; });
